export var isBrowser = typeof document !== "undefined";
//# sourceMappingURL=utils.js.map